<a
	mat-flat-button
	color="accent"
	[obgRouteLink]="resetPasswordByEmailRoute"
	[obgRouteLinkOptions]="obgRouteLinkOptions"
	test-id="reset-password-by-email-button"
	>{{ 'reset-password-method.reset-by-email' | translate }}</a
>

<a
	mat-flat-button
	color="accent"
	[obgRouteLink]="resetPasswordBySmsRoute"
	[obgRouteLinkOptions]="obgRouteLinkOptions"
	test-id="reset-password-by-sms-button"
	>{{ 'reset-password-method.reset-by-sms' | translate }}</a
>
